export type BaseQueryArgs = {
    baseUrl: string;
}

export type QueryArgs = string

export type QueryExtraOptions = object

export type QueryResult<T = unknown, M = unknown> = {
    data?: T;
    meta: {
        result: M;
    };
};

export type QueryError<T = unknown, M = unknown> = {
    status?: number;
    statusText?: string;
    data?: T;
    meta: {
        result: M;
    };
};

export const isQueryError = <T>(error: unknown): error is QueryError<T> => {
    return (error as QueryError<T>)?.status !== undefined
        && (error as QueryError<T>)?.statusText !== undefined;
};

export const isQueryResult = <T>(result: unknown): result is QueryResult<T> => {
    return (result as QueryResult<T>)?.data !== undefined;
};


export type BaseQueryRequestFn<
    Args = QueryArgs,
    Result = QueryResult,
    Error = QueryError,
    DefinitionExtraOptions = QueryExtraOptions
> = (
    args: Args,
    extraOptions?: DefinitionExtraOptions
) => Promise<Result | Error>
